import { Icon } from '@frontend/icons';
import { SurfaceHeader } from '@frontend/surface-header';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  title: string;
  appointmentsInfoText: string;
  providerName: string;
}

export const PanelHeader = ({ title, appointmentsInfoText, providerName }: Props) => {
  return (
    <SurfaceHeader.Root>
      <SurfaceHeader.Row>
        <SurfaceHeader.Title>{title}</SurfaceHeader.Title>
      </SurfaceHeader.Row>
      <SurfaceHeader.Body>
        <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
          <Icon name='calendar-small' color='light' />
          <Text size='medium' color='light'>
            {appointmentsInfoText}
          </Text>
        </div>
        {providerName && (
          <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
            <Icon name='user-small' color='subdued' />
            <Text size='medium' color='subdued'>
              {providerName}
            </Text>
          </div>
        )}
      </SurfaceHeader.Body>
    </SurfaceHeader.Root>
  );
};
